export const property = {
  createProperty: {
    title: "Crea struttura",
    of: "di",
  },
  sections: {
    details: "Dettagli della struttura",
    presentation: "Presentazione",
    rooms: "Camere",
    bookingSettings: "Impostazioni di prenotazione",
    checkinSettings: "Impostazioni di check-in",
    extras: "Servizi aggiuntivi",
  },

  menu: {
    name: "Nome",
    location: "Posizione",
    logo: "Logo della struttura",
    capacity: "Capacità",
    services: "Servizi della struttura",
    description: "Descrizione",

    roomTypes: "Tipi di camera",
    roomManagement: "Gestisci camere",

    imagesRooms: "Immagini delle camere",
    imagesProperty: "Immagini della struttura",

    priceCurrency: "Prezzo e valuta",
    rates: "Tariffe",
    maintenance: "Manutenzione della struttura",

    scheduling: "Programmazione",

    sesHospedajes: "SES Alloggi",

    smartLocks: "Serrature intelligenti",
    experiences: "Esperienze e servizi",
    chatbot: "ChatBot IA",
  },

  firstStep: {
    heading: "Qual è il nome del tuo alloggio?",
    subheading:
      "Attira gli ospiti con un nome accattivante che metta in risalto il meglio del tuo alloggio.",
    fieldLabel: "Il nome del tuo alloggio",
    placeholder: "es. Spiaggia Paradiso",
    internalNameLabel: "Nome interno",
    internalNamePlaceholder: "Nome di riferimento interno per l'alloggio",
  },

  locationStep: {
    heading: "Dove si trova il tuo alloggio?",
    subheading:
      "Fornisci l'indirizzo esatto affinché gli ospiti possano trovare facilmente il tuo alloggio.",
    countryLabel: "Paese",
    addressLabel: "Indirizzo completo",
    addressPlaceholder: "es. Via Roma 25, Milano",
    cityLabel: "Città",
    cityPlaceholder: "es. Milano",
    zipLabel: "Codice postale",
    zipPlaceholder: "es. 20121",
  },
  logoStep: {
    heading: "Qual è il logo del tuo alloggio?",
    description:
      "Aggiungi il logo del tuo alloggio per apparire più professionale ed essere più facile da riconoscere. Formati consentiti: PNG, JPG, SVG.",
    currentLogoTitle: "Logo attuale:",
    currentLogoAlt: "Logo attuale",
  },

  roomTypeStep: {
    heading: "Informazioni sulla camera",
    description:
      "Inserisci un nome per questo tipo di camera, come “Camera Doppia” o “Suite Familiare”. Questo ti aiuterà a identificarla facilmente nel calendario e nei canali di prenotazione. Dal tuo pannello potrai aggiungere gli altri tipi di camera",
    basicInfoTitle: "Informazioni di base",
    nameLabel: "Nome",
    namePlaceholder: "Nome personalizzato",
    occupancyTitle: "Capacità della camera",
    adultsLabel: "Adulti",
    childrenLabel: "Bambini",
    infantsLabel: "Neonati",
  },

  hotelRoomsStep: {
    heading: "Assegna le camere fisiche della tua struttura",
    description:
      "Crea le camere reali che saranno disponibili per le prenotazioni, come “101 - Camera Doppia” o “302 - Suite Familiare”. Questo ti aiuterà a organizzarle nel calendario e a gestire la disponibilità con facilità.",
    roomTypeLabel: "Tipo di camera",
    roomNameLabel: "Nome della camera",
    roomNamePlaceholder: "Nome personalizzato",
    roomCodeLabel: "Numero o codice della camera",
    roomCodePlaceholder: "Facoltativo",
  },

  capacityStep: {
    heading: "Condividi i dettagli essenziali sul tuo alloggio",
    description:
      "Indica il numero di ospiti, camere da letto e bagni. Nota che le camere da letto e i bagni sono considerati privati per impostazione predefinita. Se sono condivisi, potrai aggiornarlo in seguito nei dettagli della struttura.",
    labels: {
      guests: "Ospiti",
      bedrooms: "Camere da letto",
      bathrooms: "Bagni",
    },
  },

  servicesStep: {
    heading: "Mostra agli ospiti cosa offre il tuo alloggio",
    subtitle:
      "Seleziona i servizi disponibili. Potrai aggiungerne altri in seguito dal CMS.",
    services: {
      oven: "Forno e piano cottura",
      pets_allowed: "Animali ammessi",
      wifi: "Internet Wi-Fi",
      essentials: "Elementi essenziali",
      washing_machine: "Lavatrice",
      air_conditioning: "Aria condizionata",
      heating: "Riscaldamento centralizzato",
      parking: "Posto auto",
      children_allowed: "Bambini ammessi",
      refrigerator: "Frigorifero",
    },
  },

  priceStep: {
    heading: "Qual è il prezzo a notte?",
    subtitle:
      "Imposta il prezzo predefinito per creare la prima tariffa a notte, così come la valuta della tua struttura.",
    labels: {
      pricePerNight: "Tariffa a notte",
      currency: "Valuta",
    },
    placeholders: {
      priceExample: "es. 100",
    },
    requiredAsterisk: "*",
  },

  descriptionStep: {
    heading: "Come descriveresti il tuo alloggio?",
    subtitle:
      "Attira gli ospiti con una breve descrizione della tua struttura. Metti in risalto i servizi disponibili e i punti di interesse nelle vicinanze.",
    placeholders: {
      example:
        "es. Un loft elegante con vista sulla città, perfetto per lavorare, fare shopping e immergersi nell'atmosfera urbana.",
    },
    inspiration: "Hai bisogno di ispirazione?",
    buttons: {
      useAI: "Usa l'IA",
      generating: "Generazione...",
    },
    errors: {
      generate:
        "Si è verificato un errore durante la generazione della descrizione. Riprova.",
    },
  },
  navigation: {
    save: "Salva",
    next: "Avanti",
  },
  common: {
    success: "Operazione riuscita",
    error: "Errore",
    cancel: "Annulla",
    save: "Salva",
  },

  images: {
    heading: "Immagini della struttura",
    subtitleHotel:
      "Aggiungi le foto delle tue camere per poterle usare nella tua pagina di prenotazione diretta sul web.",
    subtitleApt:
      "Aggiungi le foto della tua struttura per poterle usare nella tua pagina di prenotazione diretta sul web.",

    loadRoomsError: "Impossibile caricare le camere",
    uploadSuccess: "Immagini valide caricate con successo",
    uploadErrorGeneric: "Errore durante il caricamento delle immagini",

    deleteConfirmMessage: "Sei sicuro di voler eliminare questa immagine?",
    deleteConfirmHeader: "Conferma",
    deleteAccept: "Elimina",
    deleteReject: "Annulla",
    deleteSuccess: "Immagine eliminata con successo",
    deleteError: "Errore durante l'eliminazione dell'immagine",

    setMainSuccess: "Immagine principale aggiornata",
    setMainError: "Errore durante l'impostazione dell'immagine principale",

    invalidFilesTitle: "File non validi",

    mainBadge: "Principale",
  },

  dropzone: {
    prompt: "Trascina le immagini qui o fai clic per selezionarle",
    formatHint: "Formati: JPEG, PNG, GIF.",
    uploading: "Caricamento delle immagini... {progress}%",
    invalidHeader: "Alcuni file non soddisfano i requisiti:",
    reasonType: "tipo non valido",
    reasonSize: "supera il limite di dimensione",
    and: "e",
  },

  checkin: {
    heading: "Quando verranno inviati i link per il check-in?",
    subtitle:
      "Programma l'invio automatico del link per il check-in ai tuoi ospiti.",

    options: {
      same_day: { amount: "Stesso giorno", text: "del check-in" },
      24: { amount: "24 ore", text: "prima del check-in" },
      48: { amount: "48 ore", text: "prima del check-in" },
      72: { amount: "72 ore", text: "prima del check-in" },
      disabled: { amount: "Disattiva", text: "Lo invierò manualmente" },
    },
    recommended: "Consigliato",

    details: {
      sameDay: "Ore 6:00 dello stesso giorno",
      previousNight: "Ore 18:00 della sera precedente",
      corresponding: "Ore 18:00 corrispondenti",
    },

    confirm: {
      message: "Sei sicuro di voler modificare la programmazione del check-in?",
      header: "Conferma modifica",
      accept: "Modifica programmazione",
      reject: "Annulla",
    },

    toasts: {
      loadError: {
        title: "Errore",
        body: "Impossibile caricare le impostazioni di check-in.",
      },
      saveSuccess: {
        title: "Impostazioni aggiornate",
        body: "Processo completato con successo",
      },
    },

    messages: {
      disabled: "L'invio automatico è disattivato. Dovrà essere inviato manualmente.",
      same_day: "I check-in verranno inviati alle 6:00 dello stesso giorno del check-in",
      exactly24: "I check-in verranno inviati alle 18:00 della sera prima del check-in",
      // If you don't have ICU plural, use a generic message
      daysBefore:
        "I check-in verranno inviati alle 18:00, {days} giorno/i prima del check-in",
    },
  },

  police: {
    header: "Registra i dati dell'autorità competente",
    toasts: {
      saveSuccess: {
        title: "Azione completata con successo",
        body: "I dati dell'autorità sono stati salvati con successo",
      },
    },
    errors: {
      lessorRequired: {
        title: "Errore, campo locatore",
        body: "Il codice del locatore è obbligatorio",
      },
      establishmentRequired: {
        title: "Errore, campo esercizio",
        body: "Il codice dell'esercizio è obbligatorio",
      },
    },
  },

  identity: {
    title: "Negozio del check-in",
    subtitle: "Al check-in, l'ospite riceve su WhatsApp un link con ciò che può aggiungere al soggiorno.",
    propertyLabel: "Struttura:",
    toggle: {
      title: "Abilita la verifica dell'identità",
      hint: "Se abilitata, agli ospiti verrà richiesto di verificare la propria identità.",
      on: "ON",
      off: "OFF",
    },
    config: {
      whatTitle: "Che cosa chiedi all'ospite?",
      whatHint: "Scegli le foto che dovrà scattare. Almeno una.",
      frontTitle: "Documento fronte",
      frontDesc:
        "Il lato con la foto. È quello che viene confrontato con il selfie.",
      backTitle: "Documento retro",
      backDesc:
        "Il retro, dove di solito ci sono l'indirizzo e la zona di lettura.",
      selfieTitle: "Selfie sul momento",
      selfieDesc:
        "Una foto del suo viso, scattata al momento con la fotocamera.",
      compareOn: "Il volto del documento viene confrontato con il selfie.",
      compareOff:
        "La foto viene solo conservata: senza documento e selfie non ci sono volti da confrontare.",
      requiredTitle: "E se i volti non coincidono…",
      noTitle: "Può continuare",
      noDesc:
        "Completa comunque il check-in e tu lo vedi segnalato nel pannello.",
      yesTitle: "Non può continuare",
      yesDesc:
        "Non potrà completare il check-in finché non andrà a buon fine. Può riprovare tutte le volte che serve.",
      lockedHint:
        "Per poterlo richiedere servono il documento fronte e il selfie.",
      summaryTitle: "L'ospite vedrà",
      needOne: "Devi chiedere almeno una foto.",
      noStorage:
        "In questo paese non conserviamo le foto d'identità, solo il risultato. Senza confronto facciale non resterà alcuna traccia.",
      serviceDown:
        "Se il nostro servizio di confronto si guasta, l'ospite può proseguire e tu lo vedi segnalato: nessuno resta fuori per un guasto nostro.",
    },
    toasts: {
      updated: "Impostazioni di verifica dell'identità aggiornate con successo",
      updateError: "Errore durante l'aggiornamento delle impostazioni di verifica dell'identità",
    },
  },

  guestReviews: {
    subtitle:
      "Inserisci l'URL del sito di recensioni che vuoi configurare affinché i tuoi ospiti possano lasciare il loro feedback, su Google o su un altro sito di recensioni che utilizzi. Questo aiuta a migliorare la visibilità e la reputazione dell'alloggio.",
    enableTitle: "Abilita le recensioni degli ospiti",
  },

  smartLocks: {
    title: "Serrature intelligenti",
    subtitle:
      "Collega serrature intelligenti compatibili e dimentica le chiavi fisiche. Genera e invia i codici di accesso automaticamente, senza lavoro manuale, 100% sicuro.",
    propertyLabel: "Struttura",
    compatibleTitle: "Serrature intelligenti compatibili",
    andManyMore: "e molte altre...",

    enableTitle: "Abilita la serratura intelligente",
    enableHelp:
      "Invia il codice di accesso ai tuoi ospiti una volta completato il check-in, esattamente all'orario di check-in selezionato.",

    configTitle: "Configurazione",
    configSubtitle: "Imposta le tue preferenze di invio del codice di accesso",

    deliveryLabel: "Orario di invio del codice di accesso",
    deliveryDesc:
      "Scegli l'orario in cui il codice di accesso verrà inviato al tuo ospite il giorno della sua prenotazione.",
    saveTimeBtn: "Salva orario",
    saveTimeLoading: "Salvataggio...",

    accessTypeLabel: "Tipo di codice di accesso",

    static: {
      title: "Codice statico",
      desc: "Usa lo stesso codice per tutti gli ospiti",
    },
    dynamic: {
      title: "Codice dinamico",
      desc: "Genera codici univoci per ogni prenotazione",
      soon: "Prossimamente",
    },

    masterCodeLabel: "Codice di accesso principale",
    masterCodePlaceholder: "Inserisci il tuo codice di accesso principale",
    saveCodeBtn: "Salva codice",
    saveCodeLoading: "Salvataggio...",

    masterCodeHelp:
      "Questo codice verrà inviato automaticamente agli ospiti all'orario specificato il giorno del loro check-in.",

    dynamicInfo: {
      title: "Codici di accesso dinamici",
      desc: "Questa funzione premium genererà automaticamente codici di accesso univoci per ogni prenotazione, offrendo maggiore sicurezza e una migliore esperienza per l'ospite. Disponibile a breve!",
    },

    support: {
      title: "Hai bisogno di aiuto con l'integrazione?",
      desc: "Ci integriamo con tutte le principali marche di serrature intelligenti. Il nostro team tecnico ti aiuterà a configurare il tuo modello specifico.",
      cta: "Contatta il supporto",
    },

    errors: {
      emptyKey: "Inserisci una chiave di accesso",
    },

    toasts: {
      updateSuccess: "Impostazioni della serratura intelligente aggiornate con successo",
      updateError: "Errore durante l'aggiornamento delle impostazioni della serratura intelligente",
      timeSuccess: "Orario di invio aggiornato con successo",
      timeError: "Errore durante l'aggiornamento dell'orario di invio",
      keySuccess: "Chiave di accesso salvata con successo",
      keyError: "Errore durante il salvataggio della chiave di accesso",
    },
  },

  services: {
    listMovedHelp: "L'elenco dei servizi è uno solo per tutto l'account: si scrive una volta e si sceglie in quali annunci offrirlo.",
    listMovedLink: "Vai a Servizi ed esperienze",
    title: "Esperienze e servizi",
    subtitle: "Gestisci i servizi aggiuntivi della tua struttura.",
    enableTitle: "Abilita lo store di esperienze e servizi",
    enableHelp:
      "Promuovi tutte le esperienze e i servizi aggiuntivi della tua struttura. Gli ospiti ricevono un link WhatsApp al check-in.",
    storeType: {
      title: "Tipo di store",
      internal: {
        title: "Store interno",
        desc: "Gestisci i tuoi servizi direttamente sulla piattaforma",
      },
      external: {
        title: "Store esterno",
        desc: "Reindirizza gli ospiti al tuo store esterno",
      },
    },
    externalConfig: {
      title: "Configurazione dello store esterno",
      guestMessageLabel: "Messaggio per gli ospiti",
      guestMessagePlaceholder:
        "Es.: Scopri i nostri servizi aggiuntivi e le esperienze uniche nel nostro store online...",
      guestMessageHelp:
        "Messaggio mostrato agli ospiti dopo il check-in (max. 200 caratteri)",
      urlLabel: "L'URL del tuo store esterno",
      urlPlaceholder: "https://your-external-store.com",
      urlHelp: "URL completo dove gli ospiti possono prenotare esperienze e servizi",
      noteTitle: "Nota:",
      noteText:
        "Gli ospiti riceveranno questo messaggio personalizzato con il link dopo aver completato il check-in.",
    },
    addBtn: "Aggiungi",
    delete: {
      title: "Eliminare il servizio?",
      text: "Questa azione non può essere annullata",
      confirm: "Elimina",
      cancel: "Annulla",
    },
    toasts: {
      stateUpdated: "Stato del servizio aggiornato",
      deleted: "Servizio eliminato con successo",
      storeUpdated: "Impostazioni di esperienze e servizi aggiornate con successo",
      storeError: "Errore durante l'aggiornamento delle impostazioni di esperienze e servizi",
      configUpdated: "Configurazione dello store aggiornata con successo",
      configError: "Errore durante l'aggiornamento della configurazione dello store",
    },
  },
  bot: {
    enableTitle: "Abilita l'assistente virtuale",
    enableHelp: "Automatizza l'assistenza agli ospiti con risposte rapide su WhatsApp.",
  },

  rooms: {
    heading: "Tipi di camera",
    subtitle: "Gestisci i tipi di camera della tua struttura.",
    addTypeCta: "Aggiungi tipo di camera",
    adultsCapacity: "Capacità adulti: {count}",
    emptyList: "Nessuna camera registrata.",

    deleteConfirmHeader: "Conferma eliminazione",
    deleteConfirmMessage:
      "Sei sicuro di voler eliminare questa camera? Questa azione non può essere annullata.",
    deleteConfirmAccept: "Sì, elimina",
    deleteConfirmReject: "Annulla",

    deleteSuccess: "Camera eliminata con successo.",
    deleteError: "Errore durante l'eliminazione della camera.",
  },

  roomMgmt: {
    remaining: "Disponibili: {count}",
    heading: "Gestisci camere",
    subtitle: "Assegna le singole camere ai tipi registrati.",
    totalRooms: "Totale camere: {count}",

    typeLabel: "Tipo",
    codeLabel: "Codice",
    nameLabel: "Nome",
    descLabel: "Descrizione",

    selectPlaceholder: "Seleziona",
    codePlaceholder: "Codice",
    namePlaceholder: "Nome della camera",
    descPlaceholder: "Descrizione della camera",

    addBtn: "Aggiungi",

    planLimitTitle: "Limite raggiunto",
    planLimitMsg:
      "Hai raggiunto il numero massimo di camere consentite dal tuo piano. Aggiorna il tuo abbonamento per aggiungerne altre.",

    loadTypesError: "Impossibile caricare i tipi di camera",
    loadRoomsError: "Impossibile caricare le camere esistenti",

    saveSuccessTitle: "Operazione riuscita",
    saveSuccessMsg: "Camere salvate con successo",
    saveError: "Impossibile salvare le camere",

    deleteSuccess: "Camera eliminata con successo.",
    deleteError: "Errore durante l'eliminazione della camera.",
    formIncompleteError:
      "Completa il tipo e il nome per tutte le camere.",
  },

  rates: {
    heading: "Tariffe",
    subtitleHotel: "Gestisci le tariffe dei tuoi alloggi.",
    subtitleSingle: "Gestisci le tariffe del tuo alloggio.",
    adultsCapacity: "Capacità adulti: {count}",
    roomsCount: "Camere {count}",
    singleUnit: "Unità di alloggio",

    table: {
      name: "Nome",
      occupancy: "Ospiti",
      priceTaxIncl: "Prezzo (TASSE INCLUSE)",
      actions: "Azioni",
    },

    addRate: "Aggiungi tariffa",
    emptyList: "Nessuna tariffa registrata.",

    deleteConfirmHeader: "Conferma eliminazione",
    deleteConfirmMessage:
      "Sei sicuro di voler eliminare questa tariffa? Questa azione non può essere annullata.",
    deleteConfirmAccept: "Sì, elimina",
    deleteConfirmReject: "Annulla",

    deleteSuccess: "Tariffa eliminata con successo.",
    deleteError: "Errore durante l'eliminazione della tariffa.",
  },
};

export default property;
